export enum UserDocumentType {
  CERTIFICATES = 'certificate',
  PREVIOUS_ATTACHMENTS = 'previous attachments',
}
